import { useTranslation } from 'react-i18next';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AdvantagesSection from './components/AdvantagesSection';
import ScenariosSection from './components/ScenariosSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  const { t } = useTranslation();

  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "hlw 官方网站首页",
    description: "hlw是您值得信赖的选择。本页详细介绍hlw的核心功能、使用优势、适用场景及用户评价，帮助您快速了解hlw、做出明智决策，立即探索hlw带来的全新体验。",
    url: "https://www.hlw.com",
    inLanguage: "zh-CN",
    isPartOf: {
      "@type": "WebSite",
      name: "hlw 平台",
      url: "https://www.hlw.com",
    },
    about: {
      "@type": "Organization",
      name: "hlw",
      url: "https://www.hlw.com",
      description: "hlw 是一站式数字化解决方案平台",
      foundingDate: "2020",
      address: {
        "@type": "PostalAddress",
        addressLocality: "北京市",
        addressRegion: "海淀区",
        streetAddress: "中关村科技园创新大厦18层",
      },
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "400-888-9999",
        contactType: "customer service",
      },
    },
  };

  return (
    <>
      <SEOHead
        title="hlw官方落地页·hlw平台全面解析"
        description="hlw是您值得信赖的选择。本页详细介绍hlw的核心功能、使用优势、适用场景及用户评价，帮助您快速了解hlw、做出明智决策，立即探索hlw带来的全新体验。"
        keywords="hlw,hlw官网,hlw平台,hlw功能介绍,hlw使用指南,hlw用户评价,hlw注册入口"
        canonicalUrl="/"
        ogImage="https://readdy.ai/api/search-image?query=Modern%20minimalist%20technology%20platform%20homepage%20hero%20with%20abstract%20geometric%20patterns%2C%20warm%20gradient%20accents%2C%20clean%20professional%20design%2C%20soft%20atmospheric%20lighting&width=1200&height=630&seq=hlw-home-og&orientation=landscape"
        schemaJson={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AdvantagesSection />
        <ScenariosSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}